import { render } from "./ActivityCenterTabContent.vue?vue&type=template&id=bb105a7a&scoped=true"
import script from "./ActivityCenterTabContent.vue?vue&type=script&lang=js"
export * from "./ActivityCenterTabContent.vue?vue&type=script&lang=js"

import "./ActivityCenterTabContent.vue?vue&type=style&index=0&id=bb105a7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb105a7a"]])

export default __exports__